import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_3adc9213-dab6-4851-9c35-a0c85e7e3dfd/artifacts/gaem0znj_Shoozix%20Signature.png";

const COLS = [
  {
    label: "House",
    items: [
      { name: "About", href: "#house" },
      { name: "Capabilities", href: "#capabilities" },
      { name: "Atelier", href: "#atelier" },
    ],
  },
  {
    label: "Collections",
    items: [
      { name: "Men's Footwear", href: "#collections" },
      { name: "Ladies' Footwear", href: "#collections" },
      { name: "Kids' Footwear", href: "#collections" },
      { name: "Goodyear Welted", href: "#collections" },
      { name: "True Moccasins", href: "#collections" },
      { name: "Leather Garments", href: "#collections" },
    ],
  },
  {
    label: "Trade",
    items: [
      { name: "Private Label", href: "#capabilities" },
      { name: "Sampling", href: "#capabilities" },
      { name: "Small MOQs", href: "#capabilities" },
      { name: "Contact", href: "#contact" },
    ],
  },
];

export const Footer = () => {
  const handleAnchor = (e, href) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A1430] text-[#F9F8F6] pt-24 pb-12 overflow-hidden"
    >
      {/* Decorative top */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#B8945F] to-transparent" />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Big brand mark */}
        <div className="mb-20">
          <p
            data-testid="footer-tagline"
            className="font-serif text-5xl md:text-7xl lg:text-[8rem] leading-[0.95] tracking-tight text-[#F9F8F6]"
          >
            Crafted in <em className="font-light text-[#B8945F]">India</em>.
            <br />
            Worn <em className="font-light text-[#B8945F]">worldwide</em>.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16 border-b border-[#F9F8F6]/10">
          <div className="lg:col-span-4">
            <img
              src={LOGO_URL}
              alt="Shoozix International LLP"
              data-testid="footer-logo"
              className="h-20 w-auto mb-6"
              style={{
                filter: "invert(1) grayscale(1) brightness(1.4) contrast(1.1)",
                mixBlendMode: "screen",
              }}
            />
            <p className="text-[14px] leading-relaxed text-[#F9F8F6]/65 max-w-sm">
              Shoozix International LLP — leather footwear, garments and accessories crafted by Indian artisans for the world's most considered brands.
            </p>
            <div className="mt-6 space-y-2 text-[13px] text-[#F9F8F6]/65">
              <p>
                <span className="text-[10px] tracking-[0.3em] uppercase text-[#B8945F] mr-3">Email</span>
                <a
                  href="mailto:exports@shoozix.in"
                  data-testid="footer-email"
                  className="link-underline"
                >
                  exports@shoozix.in
                </a>
              </p>
              <p>
                <span className="text-[10px] tracking-[0.3em] uppercase text-[#B8945F] mr-3">Direct</span>
                <a
                  href="tel:+911204312742"
                  data-testid="footer-phone"
                  className="link-underline"
                >
                  +91 120 431 2742
                </a>
              </p>
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.label} className="lg:col-span-2">
              <h4 className="text-[10px] tracking-[0.3em] uppercase text-[#B8945F] mb-5">
                {col.label}
              </h4>
              <ul className="space-y-3">
                {col.items.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      onClick={(e) => handleAnchor(e, item.href)}
                      data-testid={`footer-link-${item.name.toLowerCase().replace(/\s|'/g, "-")}`}
                      className="text-[14px] text-[#F9F8F6]/80 hover:text-[#B8945F] transition-colors"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-2">
            <h4 className="text-[10px] tracking-[0.3em] uppercase text-[#B8945F] mb-5">
              Workshops
            </h4>
            <ul className="space-y-3 text-[14px] text-[#F9F8F6]/80">
              <li>Agra, Uttar Pradesh</li>
              <li>Noida, Delhi NCR</li>
            </ul>
            <Link
              to="/login"
              data-testid="footer-client-login"
              className="mt-8 inline-block text-[10px] tracking-[0.3em] uppercase text-[#B8945F] border-b border-[#B8945F]/40 pb-1 hover:border-[#B8945F] transition"
            >
              Client Portal →
            </Link>
          </div>
        </div>

        {/* Bottom row */}
        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] tracking-[0.18em] uppercase text-[#F9F8F6]/45">
          <p data-testid="footer-copyright">
            © {new Date().getFullYear()} Shoozix International LLP — All rights reserved.
          </p>
          <p>Made in Agra · Made in Noida · Made by hand</p>
        </div>
      </div>
    </footer>
  );
};
